var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.3,20.8H16.7c-4.6,0-8.3,3.7-8.3,8.3v41.7c0,4.6,3.7,8.3,8.3,8.3h9.3l4.2-4.2H16.7c-2.3,0-4.2-1.9-4.2-4.2v-25h17.3 l5.5-5.5l5.5,5.5h18.5l5.5-5.5l5.5,5.5h17.3v25c0,2.3-1.9,4.2-4.2,4.2H69.9l4.2,4.2h9.3c4.6,0,8.3-3.7,8.3-8.3V29.2 C91.7,24.6,87.9,20.8,83.3,20.8z M87.5,33.3h-75v-4.2c0-2.3,1.9-4.2,4.2-4.2h66.7c2.3,0,4.2,1.9,4.2,4.2V33.3z M64.7,46.3l5.9,5.9 L55.9,66.9l14.7,14.7l-5.9,5.9L50,72.8L35.3,87.5l-5.9-5.9l14.7-14.7L29.4,52.1l5.9-5.9L50,61L64.7,46.3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/payment_failed.a1a54566.svg";
export { ForwardRef as ReactComponent };